<script lang="ts">
    import { createBlobUrl } from "../elearning.js";

    interface Props {
        src: string;
        alt: string;
    }

    let { src, alt }: Props = $props();
</script>


    {#await createBlobUrl(src)}
        <p>Media se načítají...</p>
    {:then src}
        <img {src} {alt} class="max-h-80 w-auto" />
    {/await}

